import { ActionIcon, Divider, Modal, Text } from '@mantine/core';
import "../styles/Highlight.css"
import { IconInfoCircle } from "@tabler/icons-react";
import { HighlightInfo } from './HighlightInfo';
import { useDisclosure } from '@mantine/hooks';

import { LiteYoutubeEmbed } from 'react-lite-yt-embed';

export const Highlight = ({ id, title, videoId }) => {
  const [opened, { open, close }] = useDisclosure(false);
  
  return (
    <div className="box">
      <Modal
        opened={opened}
        onClose={close}
        title="Info"
        styles={{
          header: {
            backgroundColor: "#202020"
          },
          content: {
            padding: "0% 0.5% 0.5% 0.5%",
            backgroundColor: "#202020"
          }
        }}
      >
        <HighlightInfo id={id}/>
      </Modal>
      <div className="title-and-icon">
        <Text truncate="end">{title}</Text>
        <Divider orientation="vertical" size="md"></Divider>
        <div className="icon">
          <ActionIcon styles={{ root: { background: "none" }}} onClick={open}>
            <IconInfoCircle />
          </ActionIcon>
        </div>
      </div>
      <LiteYoutubeEmbed id={videoId} lazyImage={true} mute={false}></LiteYoutubeEmbed>
    </div>
  )
}
